// @flow

import styled from 'styled-components';

const FormGroup = styled.div`
  margin-bottom: 0.75em;
  position: relative;
`;

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/FormGroup.js